const applications = Object.freeze({
  At: '6944a8f7-7f89-4ceb-ad45-537bdc0a4b1e',
});

export default applications;
